/**
 * Smaller standalone section image (acf.small_image).
 */

import Image from "next/image";
import { getMediaUrl, OPSI_PART_SPACING } from "../utils/opsiHelpers";

export const OpsiSmallImage = ({
  data,
  className = `opsi-small-image ${OPSI_PART_SPACING}`,
}) => {
  const imageUrl = getMediaUrl(data);

  if (!imageUrl) {
    return null;
  }

  const width = data?.width || 800;
  const height = data?.height || 400;

  return (
    <section className={className} data-opsi-part="small-image">
      <Image
        src={imageUrl}
        alt={data?.alt || ""}
        width={width}
        height={height}
        className="opsi-small-image__asset !rounded-[15px] mt-[30px] mb-[30px] max-[1150px]:max-w-[600px]"
      />
    </section>
  );
};
